"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class DeleteIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M9,6 L9,5 L16,5 L16,6 L18,6 L18,8 L7,8 L7,6 L9,6 Z M8,9 L17,9 L17,19 L8,19 L8,9 Z M10,11 L10,17 L11,17 L11,11 L10,11 Z M12,11 L12,17 L13,17 L13,11 L12,11 Z M14,11 L14,17 L15,17 L15,11 L14,11 Z" })))));
    }
}
exports.DeleteIcon = DeleteIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/delete.tsx
// module id = 2139
// module chunks = 0 1 2